<sm-title-bar
pageTitle="Targetted notification"
[showBackButton]="true"
[headerCustomTemplate]="addButton"
>
<ng-template #addButton>
  <button
    mat-flat-button
    color="accent"
    (click)="onCreateNewTargetNotification()"
  >
    Create new
    <mat-icon class="material-icons-round" [inline]="true"
      >add_circle</mat-icon
    >
  </button>
</ng-template>
</sm-title-bar>

<div class="row">
  <div class="col-12">
    <mat-card appearance="outlined">
     
      <div *ngIf="isLoading" class="loader">
        <mat-spinner></mat-spinner>
      </div>
      <div *ngIf="!isLoading" class="rounded-3 bg-light">
        <sm-data-table
          [columnHeaders]="tableDisplayColumns"
          [dataSource]="notificationList"
          [showMenuButton]="false"
          class="latest-user-list"
          [menuDropdownTemplate]="menuTemp"
          [showFilter]="false"
          [showPagination]="false"
          [itemsPerPage]="5"
        >
        </sm-data-table>
      </div>
    </mat-card>
  </div>
</div>

<ng-template #menuTemp let-value>
  <button mat-menu-item>
    <mat-icon class="material-icons-outlined">send</mat-icon>
    <span>Send again</span>
  </button>
  <button mat-menu-item>
    <mat-icon class="material-icons-outlined">delete_outline</mat-icon>
    <span>Delete</span>
  </button>
</ng-template>
